import React from 'react'
import {
  Collection,
  ExecuteOperationOnPipe,
  ModelWithForm,
  WhenCollectionIsNotEmpty,
  WhenModel
} from '@morningtrain/react-resources'
import { Table } from 'widgets/crud'
import { Translation } from '@morningtrain/react-translations'
import * as Columns from 'support/columns'
import * as UI from 'ui'
import { useEnvValue } from '@morningtrain/react-helpers'
import * as Displays from 'support/displays'
import FieldLabel from 'support/displays/FieldLabel'
import OnboardingStatusField from 'support/displays/OnboardingStatusField'
import EmployeeOnboardingStatusField from 'support/displays/EmployeeOnboardingStatusField'
import { CanUseModel } from '@morningtrain/react-auth'
import { ModelValueFilter, StaticFilter } from '@morningtrain/react-filters'
import DeleteModelOnClick from 'support/actions/generic/DeleteModelOnClick'
import { CallbackOnPipe } from '@morningtrain/react-pipelines'
import EmployeeFileTags from 'pages/app/files/partials/EmployeeFileTags'

export default function EmployeeOnboardingListInstance () {
  const [focusedOnboarding, setFocusedOnboarding] = useEnvValue('onboarding.focused_list', null)

  const unfocus = () => {
    setFocusedOnboarding(null)
  }

  return (
    <ModelWithForm resourceName='onboarding.onboarding_checklists' id={focusedOnboarding} clean>
      <WhenModel>
        <UI.Card>

          <UI.CardHeader>
            <span>
              <Displays.Text name='name' />
            </span>
            <UI.ButtonWrap className='my-0'>
              <UI.Button color='outlineDark' onClick={unfocus}>
                <UI.WithIcon size={5} placement='left' icon={<UI.Icons.ArrowLeft />}>
                  <Translation
                    name='actions.back_to_overview_employee_overview'
                    data={{ employee: 'model:user.name' }}
                  />
                </UI.WithIcon>
              </UI.Button>
              <DeleteModelOnClick pipes={(
                <>
                  <ExecuteOperationOnPipe
                    namespace='api' resourceName='onboarding.onboarding_checklists'
                    operationName='employee'
                  />
                  <CallbackOnPipe callback={() => unfocus()} />
                </>
              )}
              >
                <UI.DeleteButton big />
              </DeleteModelOnClick>
            </UI.ButtonWrap>
          </UI.CardHeader>

          <Collection resourceName='onboarding.onboarding_checklist_fields'>
            <StaticFilter name='onboarding_checklist' value={focusedOnboarding} />

            <WhenCollectionIsNotEmpty>
              <Table>
                <Columns.Column label={<Translation name="onboarding.task.task"/>} display={<FieldLabel/>}/>
                <Columns.Column label={<Translation name="onboarding.task.completed"/>}>
                  <CanUseModel permission="api.onboarding.onboarding_checklist_fields.toggle_completed">
                    <OnboardingStatusField
                      fulfilledFieldName="fulfilled_by_onboardee"
                      operationName="toggle_completed"
                    />
                  </CanUseModel>
                  <CanUseModel permission="api.onboarding.onboarding_checklist_fields.toggle_completed" negate>
                    <EmployeeOnboardingStatusField
                      fulfilledFieldName="fulfilled_by_onboardee"
                    />
                  </CanUseModel>
                </Columns.Column>
                <Columns.Column label={<Translation name="onboarding.task.approved"/>}>
                  <CanUseModel permission="api.onboarding.onboarding_checklist_fields.toggle_approved">
                    <OnboardingStatusField
                      fulfilledFieldName="fulfilled_by_onboarder"
                      operationName="toggle_approved"
                    />
                  </CanUseModel>
                  <CanUseModel permission="api.onboarding.onboarding_checklist_fields.toggle_approved" negate>
                    <EmployeeOnboardingStatusField
                      fulfilledFieldName="fulfilled_by_onboarder"
                    />
                  </CanUseModel>
                </Columns.Column>
              </Table>
            </WhenCollectionIsNotEmpty>
          </Collection>

        </UI.Card>

        <EmployeeFileTags>
          <ModelValueFilter name='onboarding_checklist_template_id' modelKey='template_id' />
          <WhenCollectionIsNotEmpty>
            <UI.CardHeader className='mt-8'>
              <UI.SecondaryHeading>
                <Translation name='partials.onboarding_files' />
              </UI.SecondaryHeading>
            </UI.CardHeader>
          </WhenCollectionIsNotEmpty>
        </EmployeeFileTags>

      </WhenModel>
    </ModelWithForm>
  )
}
